import UpdateSpentFactor from "./UpdateSpentFactor";

export default UpdateSpentFactor;
